import { Box, Stack, type SxProps, type Theme } from '@mui/material';
import React from 'react';

export interface SquareCardProps {
    title?: string;
    value?: string;
    Icon?: React.ElementType;
    count?: number;
    sx?: SxProps<Theme>;
}

export const SquareCard: React.FC<SquareCardProps> = ({
    title,
    value,
    count = 3,
    Icon,
    sx,
}) => {
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
                borderRadius: '8px',
                background: '#F4F6FA',
                p: 1,
                minWidth: 1 / count,
                minHeight: 1 / count,
                ...sx,
            }}
        >
            {Icon && <Icon sx={{ color: '#B2B9CD' }} />}
            <Box
                title={title}
                sx={{
                    color: '#B2B9CD',
                    fontSize: '12px',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                    overflow: 'hidden',
                }}
            >
                {title}
            </Box>
            <Box
                sx={{
                    color: '#2B395B',
                    fontWeight: 300,
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                    overflow: 'hidden',
                }}
            >
                {value}
            </Box>
        </Stack>
    );
};
